/**
 * The entry point for the UI of Progranimate
 *
 * @author Daniel Hammer
 * @author Nicholas O'Kelley
 */
// import { VarInspector } from './VarInspector.js'

import { Editor } from './interpretation/visualizers/editor.js'
import { Python } from './interpretation/representations/python.js'
import assert from 'assert'
import { InterpreterState } from './interpretation/interpreter.js';
import { NarrowedInterpretable } from './interpretation/interpretable.js';
import { Flowchart } from './flowchart/flowchart.jsx';


addEventListener("load", async () => {
    console.log("Hello")
    const flowchart = new Flowchart(document.getElementById('FlowchartArea'));
    
    const editorContainer = document.getElementById('editor-scrollable-container')
    assert(editorContainer)

    const pythonLanguage = new Python();
    await pythonLanguage.initialize();
    const editor = new Editor(editorContainer, pythonLanguage);

    var currentRoot: Map<string, NarrowedInterpretable>;
    editor.onASTChange((rootNode) => {
        console.log(rootNode)
        rootNode.keys()[0]
        console.log("AST has changed")
        currentRoot = rootNode;
        
        flowchart.clear();
        flowchart.setInterpretables(rootNode);
        flowchart.renderFlowchart();
    });
    
    flowchart.onASTChange((rootNode) => {
        console.log(rootNode)
        console.log("AST has changed from flowchart")
        flowchart.clear();
        flowchart.setInterpretables(rootNode);
        flowchart.renderFlowchart();

        // editor.setRootNode(rootNode);
    });
    
    document.getElementById('button_run').addEventListener('click', () => {
        if(currentRoot) {
            const state = new InterpreterState(currentRoot);
            state.onExecutingNodeChange((node, state) => {
                console.log("Running")
                editor.markText(node);
            })

            state.onStackChange((state) => {
                const stack_area = document.getElementById("stack-area") as HTMLUListElement
                stack_area.innerHTML = "";
                for(const frame of state.getStack()) {
                    const list_item = document.createElement('li');
                    const name = document.createElement('span');
                    name.innerText = frame.name + ":"
                    list_item.appendChild(name)
                    const ul_in_list = list_item.appendChild(document.createElement('ul'));
                    for(const identifier in frame.identifiers) {
                        const li = document.createElement('li')
                        const dat = frame.identifiers[identifier].data;
                        var string = dat.toString();
                        if(Array.isArray(dat)) {
                            console.log(dat);
                            string = '[' + (dat as any[]).map(item => item.data).join(', ') + ']'
                        }
                        li.innerText = `${identifier}: ${frame.identifiers[identifier].dataType} = ${string}`
                        ul_in_list.appendChild(li)
                    }
                    stack_area.appendChild(list_item)
                }
            });
            state.interpret(Array.from(currentRoot.keys()).at(-1))
        }
    })

    var setTab = (id:string, buttonId:string) => {
        var j, tabcontent, tablinks;
        tabcontent = document.getElementsByClassName("tabcontent");
        for(j = 0; j < tabcontent.length; j++) {
            tabcontent[j].style.display = "none";
        }
        tablinks = document.getElementsByClassName("tablinks");
        for(j = 0; j < tablinks.length; j++) {
            tablinks[j].className = tablinks[j].className.replace(" active","");
        }
        document.getElementById(id).style.display = "block";
        document.getElementById(buttonId).className += " active";
        
    }

    let tabButtons = document.getElementsByClassName("tablinks");
    let idArray:Array<string> = ["Terminal","VarInspector"];
    let idButtonArray:Array<string> = ["term-button","var-button"]
    for(let i = 0; i < tabButtons.length; i++) {
        tabButtons[i].addEventListener("click", () => setTab(idArray[i], idButtonArray[i]));
    }

});